// extracted by mini-css-extract-plugin
export default {"grade":"Sobre_grade__YbKGu","texto":"Sobre_texto__ar373","nomeCompleto":"Sobre_nomeCompleto__3e0cU","formacao":"Sobre_formacao__gWzTj","citacao":"Sobre_citacao__WSMv-"};